import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import { AdModel } from '$store/models';
import { AttachBodyItem } from '$store/attach/interface';
import { AdsState, AdsUsersLoadAction, AdsUsersLoadedAction } from '$store/ads/interface';

const initialState: AdsState = {
  loadingStatus: 'loading',
  balance: 0,
  placeBalance: 0,

  ads: [],

  adType: undefined,
  objectId: undefined,

  usersLoadingStatus: 'loading',
  users: [],
  usersAdId: 0,
};

export const { actions, reducer } = createSlice({
  name: 'ads',
  initialState,
  reducers: {
    loadAds(state) {
      state.loadingStatus = 'loading';
    },
    setAdsFailed(state) {
      state.loadingStatus = 'failed';
    },
    setAdsBalance(state, action: PayloadAction<number>) {
      state.balance = action.payload;
    },
    setPlaceBalance(state, action: PayloadAction<number>) {
      state.placeBalance = action.payload;
    },
    setAds(state, action: SetAdsAction) {
      const { ads, balance, placeBalance = state.placeBalance } = action.payload;
      state.loadingStatus = 'loaded';
      state.ads = ads;
      state.balance = balance;
      state.placeBalance = placeBalance;
    },

    setAdType(state, action: PayloadAction<AdsState['adType']>) {
      state.adType = action.payload;
    },
    setObjectId(state, action: PayloadAction<number>) {
      state.objectId = action.payload;
    },

    createPromoProfile(state, action: CreatePromoProfileAction) {},
    createPromoPost() {},
    createAd(state, action: CreateAdAction) {},

    addAd(state, action: PayloadAction<AdModel>) {
      state.ads = [action.payload, ...state.ads];
    },

    setAd(state, action: PayloadAction<AdModel>) {
      const copy = [...state.ads];
      const index = copy.findIndex((ad) => ad.id === action.payload.id);
      if (index !== -1) {
        copy[index] = action.payload;
        state.ads = copy;
      }
    },

    sendView(state, action: PayloadAction<number>) {},

    loadUsers(state, action: AdsUsersLoadAction) {
      state.usersLoadingStatus = 'loading';
      if (state.usersAdId !== action.payload) {
        state.usersAdId = action.payload;
        state.users = [];
      }
    },

    loadUsersFailed(state) {
      state.usersLoadingStatus = 'failed';
    },

    loadUsersLoaded(state, action: AdsUsersLoadedAction) {
      state.usersLoadingStatus = 'loaded';
      state.users = action.payload;
    },
  },
});

export type SetAdsAction = PayloadAction<{
  ads: AdModel[];
  balance: number;
  placeBalance?: number;
}>;
export type CreatePromoProfileAction = PayloadAction<{ cover: number; avatar: number }>;
export type CreatePromoPostAction = PayloadAction<{
  text: string;
  attachments: AttachBodyItem[];
}>;
export type CreateAdAction = PayloadAction<{
  price: number;
  spendLimit?: number;
  targetLang: string;
  targetSubscribed: boolean;
  name?: string;
  adId: number;
  currency: string;
}>;

export { reducer as adsReducer, actions as adsActions };

export const adsSelector = (state: RootState) => state.ads;
